import React from 'react';

import { HStack, Icon } from '@chakra-ui/react';

import { ReactComponent as CircularLogo } from '#assets/logo/circular.svg';
import { ReactComponent as TextLogo } from '#assets/logo/text.svg';

export const LogoHeader = () => (
  <HStack>
    <Icon as={CircularLogo} boxSize={8} />
    <Icon as={TextLogo} width={20} height={6} />
  </HStack>
);
